module.exports = __webpack_public_path__ + "static/img/15areaA_6.6ac7c26.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/15areaA_6.png
// module id = 1024
// module chunks = 1